//#region import libraries
import React from 'react';
import { useSelector, useDispatch } from "react-redux";

// Redux
import { selectExpandLocations, setExpandLocations } from '_redux/slices/timeline/timeline-control';

// Components
import NewAirportLocations from './new-airport-locations';

//#endregion

/**
 * Unified Airport Locations Panel
 * Expand/collapse is controlled by the button in TimelineTitles
 */
const AirportLocationsPanel = React.forwardRef(({ timelineHeight }, ref) => {
  const dispatch = useDispatch();
  const toggleAirportLocations = useSelector(selectExpandLocations);

  if (!toggleAirportLocations) {
    return <div ref={ref} />;
  }

  return (
    <div className='w-100' ref={ref} style={{ height: '100%' }}>
      <NewAirportLocations setToggleAirportLocations={(val) => dispatch(setExpandLocations(val))} />
    </div>
  );
});

AirportLocationsPanel.displayName = 'AirportLocationsPanel';

export default AirportLocationsPanel;